module.exports = __webpack_public_path__ + "media/images/bg01-dadfa7635dd539b9f5ffe87196240e26.png";